import axios from 'axios';
import { openCanvasMenu, closeCanvasMenu } from './offcanvasmenu';

axios.defaults.headers.common['RequestVerificationToken'] = window.globals.Token;
axios.defaults.headers.common['Ref_PageID'] = window.globals.pageId;

(() => {
	const favoriteListItems = document.querySelectorAll('.favorites__list-item');
	const wishlistButtons = document.querySelectorAll('.po-block__action-btn--wishlist');
	const offcanvasmenu = document.querySelector('.offcanvas[name="favoritelist"]');
	const listsAmount = offcanvasmenu ? offcanvasmenu.dataset.listcount : 0;

	const addProductToFavoriteListById = async listItem => {
		const productId = offcanvasmenu.dataset.prodid;
		const variantId = offcanvasmenu.dataset.variantid;
		const product = JSON.parse(decodeURIComponent(offcanvasmenu.dataset.product));
		const isCustom = offcanvasmenu.dataset.custom === 'true';
		const listId = listItem.dataset.listid;

		let apiUrl = `api/FavoriteLists/list/${listId}/${productId}`;
		if(variantId) {
			apiUrl += `/${variantId}/`;
		}

		try {
			await axios.post(apiUrl).then(() => {
				const prodObj = {
					productId: productId,
					variantId: variantId,
					listId: listId,
					isAdded: true
				};
				window.EventBus.$emit('set-favoritestate', prodObj);
				toggleFavoriteButtonIcon(prodObj);

				if(window.dataLayer) {
					const gtmListId = isCustom ? product.listid : 'product_overview';
					const gtmListName = isCustom ? product.listname : 'Product overview';
					gtmEcommerceEvents.addToWishlist(product, gtmListId, gtmListName, isCustom);
				}

			});
		} catch(err) {
			console.log(err);
		} finally {
			closeCanvasMenu();
		}
	};

	const addProductToFavoriteList = async product => {
		let apiUrl = `api/FavoriteLists/product/${product.id}`;
		if(product.variantid) {
			apiUrl += `/${product.variantid}/`;
		}

		try {
			await axios.post(apiUrl).then(({ data }) => {
				const prodObj = {
					productId: product.id,
					variantId: product.variantid,
					listId: data.listId,
					isAdded: data.added
				};
				window.EventBus.$emit('set-favoritestate', prodObj);
				toggleFavoriteButtonIcon(prodObj);

				if(data.added) {
					if(window.dataLayer) {
						gtmEcommerceEvents.addToWishlist(product, product.listid, product.listname, true);
					}
				}
			});
		} catch(err) {
			console.log(err);
		} finally {
			closeCanvasMenu();
		}
	};

	const addToWishlist = e => {
		const el = e.target;

		const product = {
			id: el.dataset.productid,
			name: el.dataset.name,
			number: el.dataset.number,
			discount: el.dataset.gtmdiscount,
			position: el.dataset.position,
			manufacturer: el.dataset.brand,
			groupname: el.dataset.category,
			listid: el.dataset.listid,
			listname: el.dataset.listname,
			variantid: el.dataset.variantid,
			price: el.dataset.gtmprice,
			value: el.dataset.gtmvalue,
			currencycode: el.dataset.currencycode
		};

		if(listsAmount <= 1) {
			addProductToFavoriteList(product);
		} else {
			offcanvasmenu.dataset.prodid = product.id;
			offcanvasmenu.dataset.variantid = product.variantid;
			offcanvasmenu.dataset.product = encodeURIComponent(JSON.stringify(product));
			offcanvasmenu.dataset.custom = true;
			
			openCanvasMenu(el.dataset.offcanvasTarget);
		}
	};

	const toggleFavoriteButtonIcon = ({ productId, variantId, isAdded }) => {
		if(!variantId) {
			variantId = '';
		}

		const targets = document.querySelectorAll(`[data-productid="${productId}"][data-variantid="${variantId}"]`);

		if(targets.length) {
			targets.forEach(target => {
				const icon = target.querySelector('.fa-heart');
				if(isAdded) {
					target.classList.add('po-block__action-btn--visible');
					icon.classList.remove('far');
					icon.classList.add('fas');
				} else {
					target.classList.remove('po-block__action-btn--visible');
					icon.classList.remove('fas');
					icon.classList.add('far');
				}
			});
		}
	};

	// Off Canvas menu listeners
	favoriteListItems.forEach(item => {
		item.addEventListener('click', () => {
			addProductToFavoriteListById(item);
		});
	});

	// Product Block action listeners
	wishlistButtons.forEach(btn => {
		btn.addEventListener('click', e => {
			addToWishlist(e);
		});
	});

})();